import React, { useEffect } from 'react';
import { ExperienceSection } from '../components/ExperienceSection';
import { SESLeadershipSection } from '../components/SESLeadershipSection';
import { CypressSection } from '../components/CypressSection';
import { ArmyLeadershipSection } from '../components/ArmyLeadershipSection';
import { CrisisSection } from '../components/CrisisSection';
export function ExperiencePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24" data-id="element-390">
      <ExperienceSection data-id="element-391" />
      <SESLeadershipSection data-id="element-392" />
      <CypressSection data-id="element-393" />
      <ArmyLeadershipSection data-id="element-394" />
      <CrisisSection data-id="element-395" />
    </div>;
}